// 水印
import { getCurrentInstance, onBeforeUnmount, ref, unref } from 'vue'

export function useWatermark() {
  let appendEl = null
  // 绘制文字背景图
  function createBase64(str, attr) {
    const can = document.createElement('canvas')
    const width = 200
    const height = 120
    Object.assign(can, { width, height })
    const cans = can.getContext('2d')
    if (cans) {
      cans.rotate((-20 * Math.PI) / 120)
      cans.font = attr?.font ?? '14px Reggae One'
      cans.fillStyle = attr?.fillStyle ?? 'rgba(0, 0, 0, 0.08)'
      cans.textAlign = 'left'
      cans.textBaseline = 'middle'
      cans.fillText(str, width / 20, height)
    }
    return can.toDataURL('image/png')
  }

  // 绘制水印层
  const watermarkEl = ref(null)
  const createWatermark = (str, attr) => {
    const id = Math.random() * 10000 + '-' + Math.random() * 10000 + '/' + Math.random() * 10000
    if (unref(watermarkEl)) {
      updateWatermark({ str, attr })
      return id
    }
    const div = document.createElement('div')
    watermarkEl.value = div
    div.id = id
    div.style.pointerEvents = 'none'
    div.style.top = '0px'
    div.style.left = '0px'
    div.style.position = 'absolute'
    div.style.zIndex = '100000'
    div.style.fontSize = '14px'
    const el = unref(appendEl)
    if (!el) return id
    const { clientHeight: height, clientWidth: width } = el
    updateWatermark({ str, width, height, attr })
    el.appendChild(div)
    return id
  }

  // 页面随窗口调整更新水印
  function updateWatermark(options) {
    const el = unref(watermarkEl)
    if (!el) return
    if (options.width) {
      el.style.width = `${options.width}px`
    }
    if (options.height) {
      el.style.height = `${options.height}px`
    }
    if (options.str) {
      el.style.background = `url(${createBase64(options.str, options.attr)}) left top repeat`
    }
    if (options.bg) {
      el.style.background = ''
    }
  }

  // 对外提供的设置水印方法
  function setWatermark(str, dom, attr) {
    appendEl = dom
    createWatermark(str, attr)
    // func()
    const instance = getCurrentInstance()
    if (instance) {
      onBeforeUnmount(() => {
        clear()
      })
    }
  }

  // 清除水印
  const clear = () => {
    const domId = unref(watermarkEl)
    watermarkEl.value = undefined
    const el = unref(appendEl)
    if (!el) return
    domId && el.removeChild(domId)
  }

  return { setWatermark, clear, updateWatermark }
}
